import { gql } from "@apollo/client";

export const getVips = gql`
  query NE_getVips($filter: niaga_vip_input) {
    sarana_get_vips(filter: $filter) {
      id
      buyer_id
      transactor_id
      niaga_usage_fee
      niaga_delta_boost
      is_mill_vip
      person {
        first_name
        last_name
      }
    }
  }
`;

export const upsertVip = gql`
  mutation NE_upsertVip($input: niaga_vip_upsert_input!) {
    sarana_upsert_vip(input: $input) {
      id
      buyer_id
      transactor_id
      niaga_usage_fee
      niaga_delta_boost
      is_mill_vip
    }
  }
`;

export const deleteVip = gql`
  mutation NE_deleteVip($id: Int!) {
    sarana_delete_vip(id: $id)
  }
`;
